import { calendlyApi } from 'nove8/api'
import {
  CALENDLY_URI,
  IS_USER_HAS_SUBSCRIPTION,
  USER_EMAIL,
} from 'nove8/constants/root-constants'

export const removeStorageData = () => {
  localStorage.removeItem(IS_USER_HAS_SUBSCRIPTION)
  localStorage.removeItem(CALENDLY_URI)
  localStorage.removeItem(USER_EMAIL)
}

export const cancelCalendlyEvent = async () => {
  const uri = localStorage.getItem(CALENDLY_URI)

  if (!uri) return

  removeStorageData()

  await calendlyApi
    .postCalendly(`${uri}/cancellation`)
    .then((response) => response.data)
    .catch((err) => console.error(err))
}
